module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], true), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], true), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.mode == 'confirm') ? _c('div', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('close', false)
      }
    }
  }, [_vm._v("\n            取消\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('close', true)
      }
    }
  }, [_vm._v("\n            確定\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1949c018!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = 193
// module chunks = 5